export default function authHeaders() {
  const currentUser = JSON.parse(localStorage.getItem('user_token') || '{}');
  return {
    headers: {
      os: 'web',
      version: '1.0.0',
      accept: 'application/json',
      language: 'en',
      Authorization: currentUser.token || ''
    }
  };
}
